import confetti from 'canvas-confetti';

import type { TaskConfettiOptions, TaskUtils } from './types';

export function triggerConfetti(options?: TaskConfettiOptions): void {
  // Caller options override the documented defaults; omitted options fall back to them.
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    ...options
  } as Parameters<typeof confetti>[0]);
}

export const confettiUtils: TaskUtils['confetti'] = {
  trigger: (options) => triggerConfetti(options)
};
